import React from "react";
import { FaPlusCircle } from "react-icons/fa";

const NewReportActions = ({ isPaid }) => {
  if (!isPaid) return null;

  return (
    <div
      className="container mt-5 p-4 border rounded shadow-sm"
      style={{
        maxWidth: "900px",
        fontFamily: "Oswald, sans-serif",
        borderColor: "#063970",
        backgroundColor: "#f8f9fa",
      }}
    >
      <p className="text-center mb-4 fw-bold text-secondary">
        If you wish to create a new report, click the{" "}
        <strong>"Create New Calculation"</strong>.
      </p>
      <div className="text-center">
        <button
          className="btn btn-success btn-lg d-flex align-items-center justify-content-center gap-2"
          onClick={() => (window.location.href = "/calculator")}
          style={{ fontFamily: "Oswald, sans-serif" }}
        >
          <FaPlusCircle size={20} /> Create New Calculation
        </button>
      </div>
    </div>
  );
};

export default NewReportActions;
